"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Duration = void 0;
class Duration {
    constructor() {
    }
    static getAttributeTypeMap() {
        return Duration.attributeTypeMap;
    }
}
exports.Duration = Duration;
Duration.discriminator = undefined;
Duration.attributeTypeMap = [
    {
        "name": "nanos",
        "baseName": "nanos",
        "type": "number",
        "format": "uint32"
    },
    {
        "name": "secs",
        "baseName": "secs",
        "type": "number",
        "format": "uint64"
    }
];
//# sourceMappingURL=Duration.js.map